import {useMemo} from "react";
import { useUserDetails } from "./useUserDetails";

//FGIV1AI 20/Mar/26
// Centralizes every feature toggle so that we centralize repeated logic in one place.
// HOW TO ADD NEW FEATURE
//1. Create new env var in .env file with prefix REACT_APP_FEATURE
//2. Map that env var in the useMemo function below with a descriptive name for the toggle
//3. Reference useFeatureToggles in any component and destructure the toggle you want to use
// e.g. const {isSienaAgentEnabled} = useFeatureToggles();
export const useFeatureToggles = () => {
    const { oktaDetails } = useUserDetails();
    return useMemo(() => ({
        // Only IT admin OR coordinators and enabled from env var
        isEDIAgentEnabled:
            (process.env.REACT_APP_FEATURE_EDI_AGENT === "true") &&
            (oktaDetails?.ediItAdmin || oktaDetails?.ediCoordinator),
        isSienaAgentEnabled: process.env.REACT_APP_FEATURE_SIENA_AGENT === "true",
    }), [oktaDetails?.ediCoordinator, oktaDetails?.ediItAdmin]);
};
